import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { translate } from 'react-polyglot'
import { isInvalid, getFormSyncErrors, getFormValues } from 'redux-form'
import ServiceDossier from '../../../components/dossiers/service/ServiceDossier'
import messageModalActions from '../../../actions/modals/messageModal'
import commentsActions from '../../../actions/dossier/common/comments'
import commonHeaderActions from '../../../actions/dossier/common/commonHeader'
import { storeDossier } from '../../../actions/dossier/commonDossierActions'
import combosActions, { fetchAllReasons, fetchCancelCombo, fetchLowestOrganizedUnits, fecthOrganizedUnitsByDossierUo, fetchEntitySubTypeCombo, fetchEntityFilterSubTypeCombo, fetchIssueEntity, fetchSameLevelOusCombo } from '../../../actions/combos/combos'
import { openModal as openCommonModal } from '../../../actions/common'
import { openDocumentManagementModal as openDocumentModal } from '../../../actions/dossier/common/documentManagementModal'
import { openDocumentEditionModal, closeAddOrEditDocumentModal } from '../../../actions/dossier/common/documentEditionModal'
import scrollerActions from '../../../actions/commons/scroller'
import buttonsHeaderActions from '../../../actions/dossier/common/buttonsHeader'
import buttonsSidebarActions from '../../../actions/dossier/common/buttonsSidebar'
import { fetchFilteredRelatedDossier } from '../../../actions/dossier/common/dossierRelatedDossiers'
import { getChangeUo, getSalesmanChangeUo, postUpdateChangeUo } from '../../../actions/dossier/common/changeUo'
import serviceDossierActions from '../../../actions/dossier/serviceDossier'
import vehicleActions from '../../../actions/dossier/common/vehicle'
import {
  fetchCustomFields
} from '../../../actions/dossier/customFields'

export function mapStateToProps (state) {
  return {
    dossier: state.serviceDossier,
    combos: state.combos,
    showManagementModal: state.documentaryManagementModal.showModal,
    windowWidth: state.windowDimensions.width,
    statusHeaderHeight: state.statusHeader.height,
    activeTab: state.buttonsHeader.activeTab,
    buttonsHeaderHeight: state.buttonsHeader.height,
    activeSection: state.buttonsSidebar.activeSection,
    relatedDossiersOrderBy: state.dossierRelatedDossiers.orderby,
    changeUo: state.changeUo,
    isInvalid: isInvalid('service_dossier')(state),
    formErrors: getFormSyncErrors('service_dossier')(state),
    formValues: getFormValues('service_dossier')(state),
    vehicleProps: state.vehicle,
    comment: state.comment,
    reason: state.reason,
    cancelCombo: state.combos.cancelCombo
  }
}

export function mapDispatchToProps (dispatch) {
  return {
    actions: bindActionCreators({
      ...serviceDossierActions,
      ...commentsActions,
      ...commonHeaderActions,
      ...buttonsHeaderActions,
      ...buttonsSidebarActions,
      ...scrollerActions,
      ...combosActions,
      storeDossier,
      fetchIssueEntity,
      openDocumentEditionModal,
      closeAddOrEditDocumentModal,
      openCommonModal,
      openDocumentModal,
      fetchEntitySubTypeCombo,
      fetchEntityFilterSubTypeCombo,
      fetchFilteredRelatedDossier,
      ...messageModalActions,
      fetchAllReasons,
      fetchLowestOrganizedUnits,
      getChangeUo,
      getSalesmanChangeUo,
      postUpdateChangeUo,
      fecthOrganizedUnitsByDossierUo,
      fetchCancelCombo,
      ...vehicleActions,
      fetchSameLevelOusCombo,
      fetchCustomFields
    }, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(translate()(ServiceDossier))
